/**
 * Requires
 */

import $ from 'jquery'
import objectFitPolyfill from 'objectFitPolyfill'
window.jQuery = $

/**
 * Modules
 */

import * as Acknowledgement from './acknowledgement'
import * as Svg from './svg'
import * as LazyLoad from './lazyload'
import * as Toggle from './toggle'
import * as SmoothScroll from './smooth-scroll'
import * as VideoEmbed from './video-embed'
import * as ExternalLinks from './external-links'
import * as AjaxForm from './ajax-form'
// import * as Tessitura from './tessitura-v6'
import * as Tessitura from './tessitura-v7'
import * as SubscribePopover from './subscribe-popover'

/**
 * Initialisation
 */

Acknowledgement.initialise()
Svg.initialise()
LazyLoad.initialise()
Toggle.initialise()
SmoothScroll.initialise()
VideoEmbed.initialise()
ExternalLinks.initialise()
AjaxForm.initialise()
Tessitura.initialise()
SubscribePopover.initialise()
